import React from 'react';
import { List } from 'components/ui';
import ListItem from 'components/template/index/list_item';
import ListHeader from 'components/template/index/list_header';
import Loader from 'components/loader';

const Index = ({ templates, sortBy, onSortChange, loading }) => {
  if (loading) return <Loader />;

  return (
    <List>
      <ListHeader
        visible={templates.templates.length > 0}
        sortBy={sortBy}
        onSortChange={onSortChange}
      />
      {templates.templates.map((template) => (
        <ListItem key={template.id} template={template} />
      ))}
    </List>
  );
};

export default Index;
